import React, { useRef } from 'react'
import ReactPortal from 'Components/ReactPortal/ReactPortal'
import RunEligibilityForm from 'MainTabs/Eligibility/Components/RunEligibilityForm'
import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew'
import CustomDraggable from 'Common/CustomDraggable/CustomDraggable'
import PopupHeader from 'Components/PopupHeader/PopupHeader'

const EligibiltyPopup = ({
    onClose,
    onEligibilityRun,
    disableDraggable = false,
    patientId = null,
    patientName = "",
    payerId = null,
    subscriberId = "",
    patientDob = "",
    patientPlanId = null,
    subscriberFirstName = "",
    subscriberLastName = "",
    patientRelation = "",
    insurancePayerTypeId = null,
    allPlans = []
}) => {
    const UNIQUE_ID = "EligibiltyPopup"
    const runEligibilityRef = useRef(null)
    const getEligibilityModel = async (response, model) => {
        if (onEligibilityRun) {
            onEligibilityRun(response, model);
        } else {
            onClose();
        }
    }

    return (
        <ReactPortal wrapperId={UNIQUE_ID}>
            <div
                data-te-modal-init
                className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75"
                id="exampleModalScrollable"
                tabIndex={-1}
                aria-labelledby="exampleModalScrollableLabel"
                aria-modal="true"
                data-te-open="true"
            >
                <CustomDraggable disableDraggable={disableDraggable} handle={`#${UNIQUE_ID}`}>
                    <div
                        data-te-modal-dialog-ref
                        className="relative w-[900px] min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg"
                    >
                        {/* Header */}
                        <div className='px-5 pt-0'>  
                            <PopupHeader uniqueId={UNIQUE_ID} heading="Run Eligibility" onClose={onClose} />
                        </div>

                        <div className="px-5 overflow-y-auto max-h-[70vh]">
                            <div className="flex items-center justify-between mb-4">
                                <h2 className="text-lg font-semibold text-gray-900">Eligibility Search</h2>
                                <CustomButtonNew onClick={() => runEligibilityRef.current?.runEligibility()} label="Run Eligibility" />
                            </div>
                            <div>
                                <RunEligibilityForm
                                    ref={runEligibilityRef}
                                    hideRunButton
                                    getEligibilityModel={getEligibilityModel}
                                    allPlans={allPlans || []}
                                    patientId={patientId}
                                    patientName={patientName}
                                    payerId={payerId}
                                    subscriberId={subscriberId}
                                    patientDob={patientDob}
                                    patientPlanId={patientPlanId}
                                    status={false}
                                    subscriberFirstName={subscriberFirstName}
                                    subscriberLastName={subscriberLastName}
                                    patientRelation={patientRelation}
                                    insurancePayerTypeId={insurancePayerTypeId}
                                />
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="flex flex-wrap items-center justify-end gap-2 p-5 ">
                            <CustomButtonNew label={"Cancel"} variant={"outline"} onClick={onClose} />
                        </div>
                    </div>
                </CustomDraggable>
            </div>
        </ReactPortal>
    )
}

export default EligibiltyPopup